export default __webpack_public_path__ + "img/Sheetal.06f35213.png";